import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { Control, Controller, FieldValues, Path, UseFormRegisterReturn } from 'react-hook-form';
import dayjs from 'dayjs';

type DateTimeInputProps<T extends FieldValues> = {
    readonly id?: string
    control: Control<T>
    readonly name: Path<T>
    readonly type?: string
    readonly className?: string
    readonly label?: string
    readonly multiline?: boolean
    readonly defaultValue?: string | number
    readonly value?: string | number
    readonly min?: number
    readonly max?: number
    readonly disabled?: boolean
    readonly hidden?: boolean
    readonly variant?: "standard" | "filled" | "outlined"
    readonly error?: boolean
    readonly helperText?: string
    // readonly ref?: MutableRefObject<any>
    register: UseFormRegisterReturn;
    // onChange(value: any): any
}

export function DateTimeInput<T extends FieldValues>(props: DateTimeInputProps<T>) {
    console.log("🚀 ~ DateTimeInput ~ props:", props)
    // return <input 
    //     type="datetime-local" 
    //     id={props.id} 
    //     defaultValue={props.defaultValue}
    //     {...props.register}
    //     title={props.label}  
    // />

    return (
        <Controller
            name={props.name}
            control={props.control}
            render={({ field, fieldState }) => (
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateTimePicker
                        {...field}
                        label={props.label}
                        value={field.value ? dayjs(field.value) : null}
                        onChange={(date) => field.onChange(date)}
                        slotProps={{
                            textField: {
                                fullWidth: true,
                                error: !!fieldState.error,
                                helperText: fieldState.error?.message,
                            },
                        }}
                    />
                </LocalizationProvider>
            )}
        />
    );

}
